// extracted by mini-css-extract-plugin
export default {"wrapper":"summary_wrapper__UDEYw"};